import platform from './node/index.js';
import * as utils from './common/utils.js';

export default {
  ...utils,
  ...platform
}



// WEBPACK FOOTER //
// ./node_modules/axios/lib/platform/index.js